import {Component, Input, OnInit} from '@angular/core';
import {Notification} from "@portals/api";

@Component({
	selector: 'portals-sentiment-analysis',
	templateUrl: './sentiment-analysis.component.html',
	styleUrls: ['./sentiment-analysis.component.scss'],
})
export class SentimentAnalysisComponent implements OnInit {
	@Input() sentiment = 0;
	@Input() postTitle = '';
	sentimentText = "";
	sentimentColor = "";
	percentage = 0

	constructor() {}


	ngOnInit(): void {
		this.percentage = ((this.sentiment+1)/2) * 100;
		if (this.sentiment >= 0.5) {
			this.sentimentText = "Very Positive";
			this.sentimentColor = "text-green-600";
		} else if (this.sentiment >= 0.1) {
			this.sentimentText = "Positive";
			this.sentimentColor = "text-green-500";
		} else if (this.sentiment >= -0.1) {
			this.sentimentText = "Neutral";
			this.sentimentColor = "text-gray-500";
		} else if (this.sentiment >= -0.5) {
			this.sentimentText = "Negative";
			this.sentimentColor = "text-red-500";
		} else {
			this.sentimentText = "Very Negative";
			this.sentimentColor = "text-red-600";
		}
	}
}
